export class CancelMyMPARequestResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "actionApprovalRequest",
            "baseName": "actionApprovalRequest",
            "type": "MPARequest",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CancelMyMPARequestResponse.attributeTypeMap;
    }
    constructor() {
    }
}
